import {
  CorporateAccount,
  getCostCenterOptionsQuery,
  getCostCenterOptionsService,
  Reservation,
} from '@lib/state';
import { Grid, GridTypeMap, TypographyProps } from '@material-ui/core';
import { of } from 'rxjs';

import React, { useEffect, useMemo } from 'react';
import { useObservable } from '../../utils';
import CostCenterFieldEditableDisplay from './cost-center-field-editable-display';

interface Props {
  reservation: Reservation;
  corporateAccount?: CorporateAccount;
  xs?: GridTypeMap['props']['xs'];
  sm?: GridTypeMap['props']['sm'];
  md?: GridTypeMap['props']['md'];
  lg?: GridTypeMap['props']['lg'];
  xl?: GridTypeMap['props']['xl'];
  labelVariant?: TypographyProps['variant'];
  valueVariant?: TypographyProps['variant'];
  dense?: boolean;
}
export const ReservationEditCostCenterGroup: React.FC<Props> = ({
  reservation,
  corporateAccount,
  labelVariant,
  valueVariant,
  dense = true,
  ...props
}) => {
  const corporateAccountId = corporateAccount?.id;

  const costCenterOptionsObservable = useMemo(
    () =>
      corporateAccountId
        ? getCostCenterOptionsQuery().costCenterOptionsByAccount(corporateAccountId)
        : of([]),
    [corporateAccountId]
  );
  const costCenterOptions = useObservable(costCenterOptionsObservable);

  useEffect(() => {
    if (corporateAccountId) {
      getCostCenterOptionsService().getCostCenterOptions(corporateAccountId);
    }
  }, [corporateAccountId]);
  const costCenterOpts = useMemo(() => {
    return costCenterOptions.map(option => ({
      key: option.costCenterFieldKey ?? '',
      value: option.value ?? '',
      label: option.label ?? '',
    }));
  }, [costCenterOptions]);

  const costCenterToOptionsMap = useMemo(() => {
    const map: Record<string, { key: string; value: string; label?: string | undefined }[]> = {};
    costCenterOpts?.forEach(option => {
      if (!map[option.key]) {
        map[option.key] = [];
      }
      map[option.key].push(option);
    });
    return map;
  }, [costCenterOpts]);

  return (
    <>
      {reservation.fields.map(field => (
        <Grid key={field.key} item {...props}>
          <CostCenterFieldEditableDisplay
            reservation={reservation}
            costCenterField={field}
            costCenterOptions={costCenterToOptionsMap[field.key]}
            config={corporateAccount?.fields.find(f => f.key === field.key)}
            dense={dense}
            labelVariant={labelVariant}
            valueVariant={valueVariant}
          />
        </Grid>
      ))}
    </>
  );
};
